import { RadioCardGroup } from 'Molecules';
import { Typography } from 'Tokens';
import {
  MaterialityState,
  MaterialityStatus,
  StandardMaterialityState,
  VSMEMaterialityStatus,
} from './DoubleMaterialityAssessment.d';
import { useParams } from 'react-router-dom';

const frameworkStandardMaterialityOptions = (
  framework: string,
  isMaterialDisabled?: boolean,
  isMaterialButPhasedInDisabled?: boolean
) => {
  if (framework == 'vsme') {
    return [
      {
        title: VSMEMaterialityStatus.material,
        disabled: isMaterialDisabled,
        subtitle: (
          <Typography variant="body" color="text.muted">
            Select if you want to <b> collect and report </b>data on the disclosure(s)
          </Typography>
        ),
        value: MaterialityState.material,
      },
      {
        title: VSMEMaterialityStatus.gatherData,
        subtitle: (
          <Typography variant="body" color="text.muted">
            Select if you want to <b> collect</b>, but <b>not report</b>, data on the disclosure(s)
          </Typography>
        ),
        value: MaterialityState.gatherData,
      },
      {
        title: VSMEMaterialityStatus.notMaterial,
        subtitle: (
          <Typography variant="body" color="text.muted">
            Select if you do <b> not </b>want to collect data on the disclosure(s)
          </Typography>
        ),
        value: MaterialityState.notMaterial,
      },
      {
        title: MaterialityStatus.phasedIn,
        disabled: isMaterialButPhasedInDisabled,
        subtitle: (
          <Typography variant="body" color="text.muted">
            Select if this standard is <b> material </b>but you are using the phase-in option
          </Typography>
        ),
        value: MaterialityState.phasedIn,
      },
    ];
  }
  return [
    {
      title: MaterialityStatus.material,
      disabled: isMaterialDisabled,
      subtitle: (
        <Typography variant="body" color="text.muted">
          Select if this standard is <b> material </b>for the group company
        </Typography>
      ),
      value: MaterialityState.material,
    },
    {
      title: MaterialityStatus.notMaterial,
      subtitle: (
        <Typography variant="body" color="text.muted">
          Select if this standard is <b>not material</b>, and you <b>don’t</b> want to collect data
          in the tool
        </Typography>
      ),
      value: MaterialityState.notMaterial,
    },
    {
      title: MaterialityStatus.gatherData,
      subtitle: (
        <Typography variant="body" color="text.muted">
          Select if this standard is <b> not material </b>but you want to collect data in the tool
        </Typography>
      ),
      value: MaterialityState.gatherData,
    },
    {
      title: MaterialityStatus.phasedIn,
      disabled: isMaterialButPhasedInDisabled,
      subtitle: (
        <Typography variant="body" color="text.muted">
          Select if this standard is <b> material </b>but you are using the phase-in option
        </Typography>
      ),
      value: MaterialityState.phasedIn,
    },
  ];
};

const frameworkDRMaterialityOptions = (
  framework: string,
  isMaterialDisabled?: boolean,
  isMaterialButPhasedInDisabled?: boolean
) => {
  if (framework == 'vsme') {
    return [
      {
        title: VSMEMaterialityStatus.material,
        disabled: isMaterialDisabled,
        subtitle: (
          <Typography variant="body" color={isMaterialDisabled ? 'text.disabled' : 'text.muted'}>
            Select if you want to <b> collect and report </b>data on the disclosure(s)
          </Typography>
        ),
        value: MaterialityState.material,
      },
      {
        title: VSMEMaterialityStatus.gatherData,
        subtitle: (
          <Typography variant="body" color="text.muted">
            Select if you want to <b> collect</b>, but <b>not report</b>, data on the disclosure(s)
          </Typography>
        ),
        value: MaterialityState.gatherData,
      },
      {
        title: VSMEMaterialityStatus.notMaterial,
        subtitle: (
          <Typography variant="body" color="text.muted">
            Select if you do <b> not </b>want to collect data on the disclosure(s)
          </Typography>
        ),
        value: MaterialityState.notMaterial,
      },
      {
        title: MaterialityStatus.phasedIn,
        disabled: isMaterialButPhasedInDisabled,
        subtitle: (
          <Typography
            variant="body"
            color={isMaterialButPhasedInDisabled ? 'text.disabled' : 'text.muted'}
          >
            Select if this DR is <b> material </b>but you are using the phase-in option
          </Typography>
        ),
        value: MaterialityState.phasedIn,
      },
    ];
  }
  return [
    {
      title: MaterialityStatus.material,
      disabled: isMaterialDisabled,
      subtitle: (
        <Typography variant="body" color={isMaterialDisabled ? 'text.disabled' : 'text.muted'}>
          Select if this DR is <b> material </b>for your company
        </Typography>
      ),
      value: MaterialityState.material,
    },
    {
      title: MaterialityStatus.notMaterial,
      subtitle: (
        <Typography variant="body" color="text.muted">
          Select if this DR is <b> not material</b>, and you <b>don’t</b> want to collect data in
          the tool
        </Typography>
      ),
      value: MaterialityState.notMaterial,
    },
    {
      title: MaterialityStatus.gatherData,
      subtitle: (
        <Typography variant="body" color="text.muted">
          Select if this DR is <b> not material </b>but you want to collect data in the tool
        </Typography>
      ),
      value: MaterialityState.gatherData,
    },
    {
      title: MaterialityStatus.phasedIn,
      disabled: isMaterialButPhasedInDisabled,
      subtitle: (
        <Typography
          variant="body"
          color={isMaterialButPhasedInDisabled ? 'text.disabled' : 'text.muted'}
        >
          Select if this DR is <b> material </b>but you are using the phase-in option
        </Typography>
      ),
      value: MaterialityState.phasedIn,
    },
  ];
};

const getDisclosureRequirementsOptions = (
  framework: string,
  isMaterialDisabled: boolean | undefined,
  isParentMaterial: boolean,
  hasPhasedInOption?: boolean,
  isMaterialButPhasedInDisabled?: boolean
) =>
  frameworkDRMaterialityOptions(
    framework,
    isMaterialDisabled,
    isMaterialButPhasedInDisabled
  ).filter((op) =>
    isParentMaterial
      ? !hasPhasedInOption
        ? op.title !== MaterialityStatus.phasedIn && op.title !== MaterialityStatus.notMaterial
        : op.title !== MaterialityStatus.notMaterial
      : !hasPhasedInOption
        ? op.title !== MaterialityStatus.phasedIn
        : true
  );

const getStandardOptions = (
  framework: string,
  isMaterialDisabled: boolean | undefined,
  isParentMaterial: boolean,
  hasPhasedInOption?: boolean,
  isMaterialButPhasedInDisabled?: boolean
) =>
  frameworkStandardMaterialityOptions(
    framework,
    isMaterialDisabled,
    isMaterialButPhasedInDisabled
  ).filter((op) =>
    isParentMaterial
      ? !hasPhasedInOption
        ? op.title !== MaterialityStatus.phasedIn && op.title !== MaterialityStatus.notMaterial
        : op.title !== MaterialityStatus.notMaterial
      : !hasPhasedInOption
        ? op.title !== MaterialityStatus.phasedIn
        : true
  );

const getCollectOnlyOptions = () => [
  {
    title: 'Collect data',
    subtitle: (
      <Typography variant="body" color="text.muted">
        Select if this DR is <b> material </b>for your company
      </Typography>
    ),
    value: MaterialityState.collectData,
  },
  {
    title: 'Do not collect data',
    subtitle: (
      <Typography variant="body" color="text.muted">
        Select if this DR is <b> not material</b>, and you <b>don’t</b> want to collect data in the
        tool
      </Typography>
    ),
    value: MaterialityState.doNotCollect,
  },
];

export const StandardMaterialityRadioGroup = ({
  value,
  defaultValue,
  onChange,
  isMaterialDisabled,
  width,
  isCollectOnly = false,
  isParentMaterial,
  hasPhasedInOption,
}: {
  value?: StandardMaterialityState | null;
  defaultValue?: StandardMaterialityState | null;
  onChange: (value: StandardMaterialityState | null) => void;
  isMaterialDisabled?: boolean;
  width?: string;
  isCollectOnly?: boolean;
  isParentMaterial: boolean;
  hasPhasedInOption?: boolean;
}) => {
  const { framework = '' } = useParams();
  return (
    <RadioCardGroup
      value={value ?? ''}
      defaultValue={defaultValue ?? undefined}
      direction="vertical"
      cardWidth={width ?? '490px'}
      withRadioBtn={true}
      isNullable={true}
      onChange={(val) => onChange(val as StandardMaterialityState)}
      options={
        isCollectOnly
          ? getCollectOnlyOptions()
          : getStandardOptions(framework, isMaterialDisabled, isParentMaterial, hasPhasedInOption)
      }
    />
  );
};

export const MaterialityRadioGroup = ({
  value,
  defaultValue,
  onChange,
  isMaterialDisabled,
  isDr,
  width,
  isCollectOnly = false,
  isParentMaterial,
  hasPhasedInOption,
  isMaterialButPhasedInDisabled,
}: {
  value?: MaterialityState | null;
  defaultValue?: MaterialityState | null;
  onChange: (value: MaterialityState | null) => void;
  isMaterialDisabled?: boolean;
  isDr?: boolean;
  width?: string;
  isCollectOnly?: boolean;
  isParentMaterial: boolean;
  hasPhasedInOption?: boolean;
  isMaterialButPhasedInDisabled: boolean;
}) => {
  const { framework = '' } = useParams();
  return (
    <RadioCardGroup
      value={value ?? ''}
      defaultValue={defaultValue ?? undefined}
      direction="vertical"
      cardWidth={width ?? '490px'}
      withRadioBtn={true}
      isNullable={true}
      onChange={(val) => onChange(val as MaterialityState)}
      options={
        isCollectOnly
          ? getCollectOnlyOptions()
          : isDr
            ? getDisclosureRequirementsOptions(
                framework,
                isMaterialDisabled,
                isParentMaterial,
                hasPhasedInOption,
                isMaterialButPhasedInDisabled
              )
            : getStandardOptions(
                framework,
                isMaterialDisabled,
                isParentMaterial,
                hasPhasedInOption,
                isMaterialButPhasedInDisabled
              )
      }
    />
  );
};
